import { inject, InjectionToken, Provider } from '@angular/core';

import { ORGANIZATION_CONTACT_SIGNAL_STORE } from '../signal-store';
import { OrganizationContactSignalState } from '@data-access/organizations/types';

export const ORGANIZATION_CONTACT_TOKEN =
  new InjectionToken<OrganizationContactSignalState>(
    'Organization Contact Signal Store',
  );

export const ORGANIZATION_CONTACT_STORE_PROVIDER: Provider = {
  provide: ORGANIZATION_CONTACT_TOKEN,
  useClass: ORGANIZATION_CONTACT_SIGNAL_STORE,
};

export function organizationContactTokenizer() {
  return inject(ORGANIZATION_CONTACT_TOKEN);
}
